// Obtener la IP/localhost

const CONFIG = {

 // BASE_URL: 'https://www.tresatec.com.ar/Demo/',  //demo Tresatec
  //API_URL: 'https://www.tresatec.com.ar/Demo/API',

   //BASE_URL: `http://${window.location.hostname}:3000/`,  // Dinámico
   //API_URL: `http://${window.location.hostname}/tresatecedutech/tresaedu-git/PLataforma-educativa--Tresatec-Demofinal/API`, // Dinámico

  //CON https
  BASE_URL: 'https://www.institutopetitdemeurville.com.ar/',  //Localhost
  API_URL: 'https://www.institutopetitdemeurville.com.ar/API'

};

export default CONFIG;

